<template lang="html">
    <data-table
        :headers="datatable.headers"
        :toolbar="datatable.toolbar"
        :actions="datatable.actions"
        :endpoint="datatable.endpoint"
        @rowClick="rowClick"
        storeId="requests"
        ref="list"
    >
        <template slot="items" slot-scope="props">
            <td class="text-xs-left message">
                <template v-if="props.item.type == 'separator'">
                    <b>{{props.item.title.length >= 25 ? props.item.title.substring(0,25)+ ' ...' : props.item.title}}</b>
                </template>
                <template v-else>
                    <template v-if="props.item.symbol && props.item.symbol.title">
                        {{props.item.symbol.title.length >= 25 ? props.item.symbol.title.substring(0,25)+ ' ...' : props.item.symbol.title}}
                    </template>
                    <template v-else-if="props.item.title">
                        {{props.item.title.length >= 25 ? props.item.title.substring(0,25)+ ' ...' : props.item.title}}
                    </template>
                    <template v-else> - </template>
                </template>
            </td>
            <td class="text-xs-right message">
                <template v-if="props.item.symbol && props.item.symbol.message">
                    {{props.item.symbol.message.length >= 25 ? props.item.symbol.message.substring(0,25)+ ' ...' : props.item.symbol.message}}
                </template>
                <template v-else-if="props.item.message">
                    {{props.item.message.length >= 25 ? props.item.message.substring(0,25)+ ' ...' : props.item.message}}
                </template>
                <template v-else> - </template>
            </td>
            <td class="text-xs-right">
                {{moment(props.item.created_at).format('DD/MM/YYYY')}}
            </td>
            <td class="text-xs-right">
                <avatar :item="props.item.user" :tooltip="true"></avatar>
            </td>
        </template>

    </data-table>
    </template>
</template>

<script>
import DataTable         from '../../../components/DataTable.vue'
import CreateComment     from './CreateComment.vue'
import ImportRequests    from './ImportRequests.vue'
import moment            from 'moment'
import { CommentTypes }  from '../../../config/enum/CommentTypes'
import Avatar            from '../../../components/avatar/Avatar.vue'

export default {
	components: { DataTable, Avatar },

	data() {
		return {
		    moment,
			datatable: {
				actions: [
					{ text: 'Ajouter une demande', icon: 'add_circle', callback: () => {
                         this.$eventHub.$emit('open-modal', CreateComment,{
                             product_id : this.$store.state.single.data.id,
                             product_label: this.$store.state.single.data.label,
                             element_type: 'request',
                             create_query: true
                         }) } },
                    { text: 'Importer des demandes', icon: 'import_export', callback: () => this.$eventHub.$emit('open-modal', ImportRequests), level:60},
				],
				headers: [
					{ text: 'Titre',      sortable: false, value: 'title', align: 'left' },
					{ text: 'Message',    sortable: false, value: 'message', align: 'right' },
					{ text: 'Date',       sortable: false, value: 'created_at', align: 'right' },
          { text: 'Auteur',     sortable: false, value: 'user_id', align: 'right' },
				],
				endpoint: {
					base: '/api/requests',
					filters: 'product_id|=|' + this.$route.params.id,
					embed: 'user,symbol',
                    order: 'position'
				}
			},
		}
	},
	methods: {
        rowClick(item) {
            this.$eventHub.$emit('open-modal', CreateComment, {
                product_id : this.$store.state.single.data.id,
                product_label: this.$store.state.single.data.label,
                id : item.id,
                element_type: 'request'
             });
        },
		getCommentColor: function(type) {
			let commentType = CommentTypes.find((el) => {
				return el.value === type
			});
			return commentType ? commentType.color : '';
		},
	},
	created() {

		this.$eventHub.$on('reload-list', () => {
			if(this.$refs.list) {
				this.$refs.list.reload()
			}
		})
	},
}
</script>

<style lang="stylus" scoped>


</style>



// WEBPACK FOOTER //
// src/views/products/single/Requests.vue